{
  "accept": "동의하기",
  "activate account": "계정 활성화",
  "added doctor to favorite doctror": "{name}님을 관심 의사로 등록하였습니다.",
  "addFiles": "첨부파일",
  "after payment is confirmed, completed.": "결제확인 후 접수가 완료됩니다.",
  "agree": "동의",
  "agree to all terms and conditions": "모든 약관을 동의합니다.",
  "agree to all terms and conditions.": "모든 약관을 동의합니다.",
  "agreeAll": "모두 동의",
  "Agreement": "이용약관",
  "Agreement Content": "이용약관",
  "allowingRecive": "수신동의",
  "attach files": "파일 첨부",
  "attached files": "파일 첨부",
  "Attachments": "첨부",
  "available email": "사용 가능한 이메일",
  "back": "뒤로가기",
  "birthDate": "생년월일",
  "CalcelHeader": "취소하시겠습니까?",
  "cancel": "취소",
  "Cancel": "취소",
  "cancel payment and reservation": "결제취소 및 취소",
  "cancel reservation": "예약 취소",
  "canceled": "취소",
  "Canceled": "취소",
  "change": "변경",
  "change docor": "의사변경",
  "change password": "패스워드 변경",
  "changed password": "비밀번호가 변경 되었습니다.",
  "changePassword": "비밀번호 변경",
  "check email": "{email} 메일을 확인 바랍니다.",
  "check email verificaion": "이메일 중복 확인을 해주세요.",
  "check payment": "결제확인",
  "check prescription": "처방전 확인",
  "check spam mail box": "스팸 메일함을 확인해주세요",
  "Check your email or password": "로그인 정보를 확인하세요.",
  "CheckingItNow": "확인 중 입니다.",
  "chief complaint": "주증상",
  "chief complaint & files": "증상 및 파일 첨부",
  "close": "닫기",
  "complete": "완료",
  "complete to sign-up": "버튼을 선택하면 회원가입이 완료됩니다.",
  "Completed": "회신완료",
  "confirm": "확인",
  "confirm cancel reservation": "예약 취소 후 수정이 불가능합니다. ^ 해당 예약을 취소 하시겠습니까?",
  "confirm delete file": "해당 파일을 삭제 하시겠습니까?",
  "confirm new password": "신규 비밀번호 확인",
  "confirm reservation": "예약 확정",
  "confirm withdrawal": "정말 탈퇴하시겠습니까?",
  "confirm2": "내용 확인",
  "confirmed within one hour on average": "평균 1시간 이내 확정",
  "confirmemail": "메일확인",
  "connected count to room": "{count}명 참가 중",
  "Copied to clipboard": "클립보드에 복사하였습니다.",
  "copy share link": "초대 링크 복사",
  "DataType": "파일종류",
  "date (from)": "시작일",
  "date (to)": "시작일",
  "dayNames": "일요일,월요일,화요일,수요일,목요일,금요일,토요일",
  "dayNamesMin": "일,월,화,수,목,금,토",
  "dayNamesShort": "일,월,화,수,목,금,토",
  "DCS": "원격협진서비스",
  "default": "기본",
  "desired date": "희망 진료일",
  "desired date/time": "희망 일시",
  "desired date/time can be selected after doctor selected": "희망일자 및 희망시간은 의사 선택 후 선택 및 수정가능",
  "desired time": "희망 진료 시간",
  "did you not receive verification code via email": "혹시 인증번호를 메일로 받지 못하였나요?",
  "didnt receive verification email": "인증메일을 받지 못하셨나요?",
  "direct input": "직접입력",
  "Dispense": "조제완료",
  "do change": "변경하기",
  "do not show one week": "7일간 표시 안함",
  "do save": "저장하기",
  "doctor": "의사",
  "doctor name": "의사명",
  "doctor or dept": "의사 or 진료과",
  "doctor response": "의사회신",
  "download": "다운로드",
  "Drag and drop files to here to upload.": "첨부 파일을 마우스로 끌어 넣으시거나 [파일선택] 버튼을 클릭하세요.",
  "drop files to here": "파일을 드롭하세요",
  "edit": "수정",
  "edit personal information": "개인정보수정",
  "edit requested data": "신청 내용 수정",
  "email": "이메일",
  "email already in use": "이미 사용중인 이메일",
  "email confirmed": "메일인증이 확인되었습니다.",
  "EmailCheck": "중복확인",
  "EmailSendOK": "입력하신 이메일로 메일이 발송되었습니다.",
  "emptyMessage": "",
  "enter at least two characters without spaces": "공백 제외 두글자 이상 입력하세요.",
  "error": "오류",
  "Error": "에러",
  "error occured. please retry later": "오류 발생, 잠시 후 다시 시도해주세요.",
  "expire date": "만료일",
  "Failed to copy to clipboard": "클립보드에 복사할 수 없습니다.",
  "failed to save": "저장 실패",
  "failed to sign up": "회원 가입 실패",
  "familyName": "성",
  "favorite doctors": "관심의사",
  "female": "여자",
  "fetch failed": "서비스에 연결할 수 없습니다.",
  "file-list": {
    "desc": {
      "a": "DICOM 영상은 .ZIP 파일로 압축 후 업로드",
      "b": "아이폰에서 촬영한 영상이 보이지 않을 때",
      "c": "여기",
      "d": "를 눌러",
      "e": "[미디어 캡처하기]",
      "f": "를 참고하세요"
    }
  },
  "FileAttachments": "증상사진첨부",
  "FileCancel": "첨부 취소",
  "FileChoose": "파일 선택",
  "FileManager": "파일 관리",
  "FileTitle": "파일이름",
  "FileType": "파일확장자",
  "Fileupload": "파일 첨부",
  "fill-form-data": "가입에 필요한 필수 정보를 입력해 주세요.",
  "filtered by dept": "진료과로 검색",
  "finding keywords (requested)": "의사, 병원, 진료과 등",
  "finished sign up": "완료됩니다.",
  "first name": "이름",
  "firstName": "이름",
  "fold": "접기",
  "forgotPassword": "비밀번호 분실",
  "ForOpinion": "진료신청",
  "from date": "시작일",
  "full name": "성함",
  "home": "홈",
  "home-intro-1": "지금 까지와 다른 진료,",
  "home-intro-2": "조금 더 편리한 의료 서비스",
  "how to take appointment for non-face-to-face cooperation": "전문의를 선택하여 증상을 전송하면 예약 신청이 완료됩니다.",
  "impossible to confirm": "확인 불가",
  "InfoModify": "회원정보수정",
  "input chief complaint": "주증상 입력",
  "input new password": "새로운 비밀번호를 입력해주세요.",
  "input new password confirm": "새로운 비밀번호를 다시 한 번 입력해주세요.",
  "input old password": "기존 비밀번호를 입력해주세요.",
  "input your email address": "회원가입시 입력한 이메일을 입력하세요",
  "input-email": "이메일주소를 입력해 주세요.",
  "input-password": "비밀번호를 입력해 주세요.",
  "insertDateTime": "신청일자",
  "invited-info": "참가자 이름과 초대 암호를 입력하신 후 참가하기를 해 주세요. 초대자가 방 생성을 한 후에 참가 가능합니다.",
  "invited-title": "화상 채팅 초대",
  "inviter": "초대자",
  "join": "가입하기",
  "join chat": "채팅에 참가",
  "korea standard time": "한국표준시",
  "last name": "성",
  "LastOrder": "최근 결제",
  "legal": "개인정보처리방침 / 이용약관",
  "List of Doctors": "의사 선택",
  "login failed": "로그인 오류",
  "make sure the correct email address": "정확한 이메일 주소를 등록하셨는지 확인해주세요",
  "male": "남자",
  "medically-vulnerable": "메디컬렉션 - 진료예약 · 비대면 진료",
  "mofidy requested second opinion": "소견 신청 수정",
  "monthNames": "1월,2월,3월,4월,5월,6월,7월,8월,9월,10월,11월,12월",
  "monthNamesShort": "1월,2월,3월,4월,5월,6월,7월,8월,9월,10월,11월,12월",
  "more": "더 보기",
  "my doctors": "관심 의사",
  "my page": "마이페이지",
  "MyPage": "마이페이지",
  "name": "성함",
  "new password": "신규 비밀번호",
  "newPassword": "새로운 비밀번호",
  "newPasswordConfirm": "새로운 비밀번호 확인",
  "newRequest": "신청하기",
  "newRequestOnlineCare": "예약신청",
  "newRequestSecondOpinion": "진료 의뢰 신청하기",
  "next": "다음",
  "Next": "다음",
  "No": "아니오",
  "non-face-to-face cooperation": "비대면 진료",
  "not confirmed email": "이메일 확인 불가",
  "ok": "확인",
  "online-care-intro-1": "일반적인 증상부터 중증 질환까지 방문 진료 예약",
  "online-care-intro-2": "또는 비대면 진료를 이용할 수 있습니다.",
  "OnlineCare": "온라인 대면진료 (처방전)",
  "Page not found": "페이지를 찾을 수 없습니다.",
  "paid history": "결제 내역",
  "paid list": "결제내역",
  "paid then completed": "결제 후 접수가 완료됩니다.",
  "participant": "참가자",
  "password": "비밀번호",
  "password changed": "패스워드가 변경되었습니다.",
  "Password not correct": "비밀번호가 일치하지 않습니다.",
  "password was changed or expired": "패스워드가 이미 변경되었거나 변경 기간이 만료되었습니다.",
  "password-rules": "6자리이상 문자, 숫자",
  "passwordConfirm": "비밀번호 확인",
  "pay": "결제",
  "payment": "결제",
  "PayReady": "결제 대기",
  "pharmacy": "약국",
  "PharmacyNone": "선택 안함",
  "Phone number": "전화 번호",
  "phoneNumber": "휴대폰 번호     ",
  "pi-agreement": "개인정보 제공 동의",
  "prescription": "처방전",
  "Prev": "이전",
  "previous": "이전",
  "privacy": "개인정보처리방침",
  "Privacy Policy": "개인정보 처리방침",
  "Privacy Policy Content": "개인정보 처리방침",
  "proceeding": "진행 중",
  "profile": "개인정보",
  "quick": "빠른",
  "quick reservation description": "선호하는 의사 및 희망 일/시 선택을 통해 진료를 신청합니다.",
  "ReceptionCompleted": "접수 완료",
  "ReceptionSaveHeader": "접수 하시겠습니까?",
  "recommendted browsers": "권장 브라우저",
  "refresh": "새로고침",
  "refund and reject": "환불완료 및 반려",
  "refunded": "환불처리",
  "Refused": "반려",
  "registrationcompleted": "가입완료",
  "reject": "철회하기",
  "rejected": "반려",
  "remember me": "로그인 유지",
  "remove": "삭제",
  "Remove": "삭제",
  "request": "의뢰",
  "request appointment": "접수하기",
  "request comments": "예약 코멘트",
  "request kind": "유형",
  "request quick reservation": "빠른 진료 신청",
  "request reservation": "신청 접수",
  "request second opinion": "진료 의뢰 요청",
  "requested": "신청",
  "Requested": "예약신청",
  "requested and wait payid": "신청 및 결제대기",
  "requested count": "신청 내역",
  "requested detail information": "신청 상세 정보",
  "requested list": "신청내역조회",
  "RequestedQuick": "빠른 진료",
  "required": "필수",
  "Required information is required": "필수 정보를 입력하세요.",
  "required phone number for servie": "서비스 이용을 위해 휴대폰 번호를 입력하세요.",
  "resend verification email": "인증 메일 재발송",
  "reserved date/time": "예약 일시",
  "reset": "선택취소",
  "reset password": "비밀번호 초기화",
  "resetpassword": "패스워드 변경",
  "resetPasswordCompleted": "패스워드 변경 성공",
  "respond count": "회신 완료",
  "respond list": "완료 내역",
  "respondDateTime": "회신일자",
  "responded": "완료",
  "response": "회신",
  "Result": "결과",
  "Return": "되돌아가기",
  "room name": "방이름",
  "room status": "방 상태",
  "save": "저장",
  "save response": "회신 저장",
  "Saved": "저장 완료.",
  "saved requesting reservation": "신청 접수가 완료되었습니다.",
  "SavedFavorites": "주치의로 선택하였습니다.",
  "SaveHeader": "저장 하시겠습니까?",
  "Scheduled": "예약확정",
  "scheduled date/time": "예약일시",
  "scheduledDatetime": "예약일시",
  "search": "검색",
  "search failed": "검색 오류",
  "second opinion": "진료 의뢰",
  "second-opinion-intro-1": "타 병원 암치료, 수술 등 검사파일을 바탕으로",
  "second-opinion-intro-2": "전문의 소견이 필요한경우",
  "SecondOpinion": "진료 의뢰 (2차 소견)",
  "SecondOpinion2": "진료 의뢰",
  "Select a Dept": "진료과 선택",
  "select a hospital": "병원 선택",
  "Select a hospital": "병원 선택",
  "select a hospital to requesting": "진료를 받을 병원을 선택하세요.",
  "select desired date/time": "희망 일시 선택",
  "select doctor": "의사 선택",
  "select hopital and doctor": "병원 및 의사선택",
  "sent confirming email": "인증 메일이 발송되었습니다.",
  "sent verification email": "인증메일이 발송 되었습니다.",
  "serious illness": "중증 질환",
  "sex": "성별",
  "sexF": "여자",
  "sexM": "남자",
  "show detail": "자세히보기",
  "show detail profile": "프로필 상세보기",
  "sign in": "로그인",
  "Sign in": "LOGIN",
  "sign out": "로그 아웃",
  "sign up": "회원 가입",
  "sign-in-titl-1": "진료시간을 선택해 비대면 협진을 받을 수 있고,",
  "sign-in-titl-2": "중증질환에 대한 2차 소견을 제공하는 서비스입니다.",
  "sign-up": "회원가입",
  "signin": "로그인",
  "Signout": "로그아웃",
  "signup": "회원가입",
  "signup-title": "아직 회원이 아니세요?",
  "signup-title-1": "회원 관리를 위하여 아래와 같이 개인정보를 수집·이용 및 제공하고자 합니다.",
  "signup-title-2": "내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.",
  "sms": "문자",
  "Status": "현황",
  "submit": "제출",
  "submit application": "접수하기",
  "take appointment": "진료 신청",
  "take appointment for non-face-to-face cooperation": "진료 예약 및 비대면 진료 신청",
  "take average one week": "3~7일 소요",
  "terms of use": "이용약관",
  "there is no selectable doctors": "선택 가능한 의사가 없습니다.",
  "time standard": "기준",
  "title": "제목",
  "to date": "종료일",
  "toggle favarite doctor": "한 번 더 클릭하여 관심의사를 해제할 수 있습니다.",
  "totalCallTime": "통화시간",
  "Unable to load user": "사용자를 찾을 수 없습니다.",
  "unfold": "열기",
  "update is completed": "수정 되었습니다.",
  "User account locked out": "로그인 시도 초과, 잠시 후 다시 시도하세요.",
  "User changed their password Failed": "비밀번호를 다시 확인해주세요",
  "User not found": "사용자를 찾을 수 없습니다.",
  "userInfo": "사용자 정보",
  "userName": "사용자 이름",
  "validateError": "필수 입력 항목을 입력하세요.",
  "Video": "화상상담",
  "video chat": "화상진료",
  "view prescription": "처방전 보기",
  "withdrawal": "회원탈퇴",
  "withdrawal info1": "회원 탈퇴를 하시면 회원님의 진료기록이",
  "withdrawal info2": "모두 삭제되며 복구가 되지 않습니다.",
  "WithdrawalHeader": "회원을 탈퇴합니다.",
  "Yes": "예",
  "Your email is not verified": "가입한 이메일로 메일을 보냈습니다. \n 이메일을 열어 [계정활성화] 버튼을 눌러 주세요. \n 그 다음, 로그인이 가능합니다.",
  "Links Komef": "KOMEF에 의한 연결",
  "logging in": "서비스에 로그인 하고 있습니다.",
  "login-title": "링크로 로그인",
  "login successful": "로그인 성공",
  "face-to-face cooperation": "진료 예약",
  "appointmentTypes": {
    "appointment": "진료 예약",
    "telemedicine": "비대면 진료"
  },
  "appointment type":"예약",
  "hospital & dept": "병원 / 진료과"
}
